import React from "react";
import { currencyUSD } from "../../helpers/forms/formater";
import { AlertTriangle, Pencil, Trash2 } from "lucide-react";
import CustomSelect from "../../components/form/CustomSelect";
import { Tooltip } from "react-tooltip";

const Columns = (addUpd, categories, rows, setRows, setItems,items) => {
    const asignCategory = (row, id) => {
        console.log(row)
        const exists = rows.find(r => r.id === row.id);

        if (exists) {
            // Si ya existe, actualiza el existente
            const updatedRows = rows.map(r =>
                r.id === row.id ? { ...r, category_id: id } : r
            );
            setRows(updatedRows);
        } else {
            // Si no existe, agrégalo al arreglo
            setRows([...rows, { ...row, category_id: id }]);
        }
    };

    const editItem = (item) => {
        console.log(item)
        const newArray = items.map((i) => {
            if (item.id === i.id) {
                return {
                    ...i,
                    
                        category_id: null,
                        category: {},
        
                    error: 'No existe categoria'
                };
            }
            return i;
        });
        setItems(newArray)
        const productsSnCategory = newArray
            .filter(pr => !pr?.category_id)
            .map(pr => pr);

        setRows(productsSnCategory);
    }

    let columns = [
        {
            id: "sku",
            name: "SKU",
            selector: (row) => `${row.sku}`,
        },
        {
            id: "name",
            name: "Descripcion",
            selector: (row) => `${row.name}`,
        },
        {
            id: "category",
            name: "Area",
            selector: row => (
                <div className="flex items-center gap-2 relative">
                    {row.category?.name ?
                        <>
                            <span>{row.category.name}</span>
                            <button onClick={() => editItem(row)} className="text-blue-500 hover:text-blue-700">
                                <Pencil size={16} />
                            </button>
                        </>
                        :

                        <div className="min-w-[160px]">
                            <CustomSelect
                                className="text-sm"
                                holder="Area"
                                options={categories}
                                value={rows.find((r) => r.id == row.id)?.category_id}
                                handleChange={(e) => asignCategory(row, e.target.value)}
                            />
                        </div>


                    }

                    {(row.error && rows.find((r) => r.id == row.id)?.category_id == null) && (
                        <div className="text-fr-danger" data-tooltip-id={`error-${row.id}`}>
                            <AlertTriangle size={16} />
                            <Tooltip id={`error-${row.id}`} place="top">
                                {row.error}. Clic para seleccionar  asignar area
                            </Tooltip>
                        </div>
                    )}

                    {(row.error && rows.find((r) => r.id === row.id)?.category_id != null) && (
                        <div className="text-fr-success" data-tooltip-id={`error-${row.id}`}>
                            <AlertTriangle size={16} />
                            <Tooltip id={`error-${row.id}`} place="top">
                                {row.error}. Area asignada
                            </Tooltip>
                        </div>
                    )}
                </div>
            ),

        },
        {
            id: "unit_price",
            name: "Precio unitario",
            
            selector: (row) => (
                <span className="text-fr-accent font-semibold bg-fr-accent/10 px-3 py-1 rounded-full text-sm">
                    {currencyUSD(row.unit_price ?? 0)}
                </span>
            ),
        },
        {
            id: "sales_month",
            name: "Ventas del mes",
            selector: (row) => (
                <span className="text-fr-success font-semibold bg-fr-success/10 px-3 py-1 rounded-full text-sm">
                    {currencyUSD(row.params_month ?? 0)}
                </span>
            ),
        },
        {
            id: "sales_quarter",
            name: "Ventas de la 15na",
            selector: (row) => (
                <span className="text-fr-accent font-semibold bg-fr-accent/10 px-3 py-1 rounded-full text-sm">
                    {currencyUSD(row.params_quarter ?? 0)}
                </span>
            ),
        },
        
        {
            id: "units",
            name: "Unidades vendidas",
            selector: (row) => (
                <span className="text-fr-success font-semibold bg-fr-success/10 px-3 py-1 rounded-full text-sm">
                    {currencyUSD(row.sales_units ?? 0)}
                </span>
            ),
        },
        
        {
            id: "acciones",
            name: "Acciones",
            selector: (row) => (
                <div className="flex items-center gap-3">
                    <button
                        className="text-fr-primary hover:text-fr-primary-hover transition"
                        onClick={() => addUpd(row)}
                        title="Editar"
                        disabled={true}
                    >
                        <Pencil size={18} />
                    </button>
                </div>
            ),
        },
    ];
    return columns;
};

export default Columns;
